export default __webpack_public_path__ + "static/media/Jones_03.f53dcdc0.jpg";